<template>
  <div>
    <SloButton :fill="buttonFill" @click="showModal = true">
      {{ buttonLabel | t }}
    </SloButton>
    <transition name="fade-up">
      <SloModal
        v-if="showModal"
        :form="false"
        :maxWidth="600"
        @dismiss="showModal = false"
        class="c-gray-900"
      >
        <template v-slot:title>
          <span class="fw-medium">{{ modalTitle | t }}</span>
        </template>
        <slot name="modal-content" />
      </SloModal>
    </transition>
  </div>
</template>

<script>
import SloButton from './SloButton.vue';
import SloModal from './SloModal.vue';
import t from '../../js/main/i18n';

export default {
  name: 'SloButtonModal',
  components: {
    SloButton,
    SloModal
  },
  props: {
    buttonFill: {type: String, default: 'solid'},
    buttonLabel: {type: String, required: true},
    modalTitle: {type: String, required: true}
  },
  filters: {
    t
  },
  data() {
    return {
      showModal: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/system';

:deep(.slo-modal-frame header button) {
  padding: 0 !important;
  color: $color-gray-600;

  &:hover {
    color: $color-gray-900;
  }
}
</style>
